import React from "react";

export default function Timeline() {
  return (
    <div className="pt-8 sm:pt-12 md:pt-16 lg:pt-20 bg-[#f9f9f9]">
      <div className="px-4 sm:px-6 md:px-8 lg:px-10  mx-auto">
        {/* Heading */}
        <h2 className="md:text-left text-center lg:ps-20 xl:ps-32 sm:ps-20 font-robout text-[#d78558] text-[2.5rem] sm:text-[3rem] md:text-[3rem] lg:text-[5rem] xl:text-[6rem] 2xl:text-[8.8rem] 3xl:text-[10.8rem] leading-tight tracking-[-.03em] lowercase mb-5 lg:mb-40 font-black">
          <span data-aos="fade-up">Meet our</span> <br />
          <span data-aos="fade-up" className="md:ml-[8.5rem] ml-[0.8rem]">
            Medical Directors
          </span>
        </h2>

        {/* Content */}
        <div className="flex flex-col xl:flex-row md:gap-8 mt-12 lg:gap-28 max-w-7xl mx-auto pb-10">
          {/* Text */}
          <div className="w-full xl:w-1/2 flex flex-col justify-center lg:mb-0 mb-12">
            <div className="text-center flex flex-col gap-4">
              <h3
                data-aos="fade-up"
                className="text-[#d78558] font-robout text-2xl sm:text-3xl md:text-4xl lg:text-[3rem] leading-tight font-black"
              >
                Kamlesh A. Amin, MD
              </h3>
              <span
                data-aos="fade-up"
                data-aso-delay="100"
                className="text-[#1d1d1f] text-sm sm:text-base md:text-lg lg:text-[1.3rem] font-robout"
              >
                - Diplomate, American Board of Radiology
              </span>
            </div>
            <div className="text-[#1d1d1f] text-lg md:text-lg lg:text-xl xl:text-[1.35rem] mt-6 sm:mt-8 md:mt-10 font-robout md:leading-relaxed">
              <p data-aos="fade-up" data-aso-delay="200">
                With over 4 decades of experience in radiology,{" "}
                <span className="whitespace-nowrap">Dr. Samir A. Amin</span> has
                been the driving force and backbone of the Citrus Diagnostic
                Center. Completed his residency at Wayne State University in
                Detroit in the year 1983, he was shifted to Citrus Company in
                1989 where he led the foundation of Citrus Diagnostic Center.
              </p>
              <p data-aos="fade-up" data-aso-delay="300" className="mt-4">
                He practiced and became proficient in every aspect of diagnostic
                imaging. He has a keen interest in Nuclear Medicine, CT, and
                MRI. He earned the reputation of being a trusted doctor through
                his dedication by providing personalised treatment services with
                timely and precise results.
              </p>
              <p data-aos="fade-up" data-aso-delay="300" className="mt-4">
                <b>Professional Memberships:</b> <br /> American College of
                Radiology, <br />
                Radiological Society of North America,
                <br />
                Florida Radiological Society,
                <br />
                Citrus County Medical Society.
              </p>
            </div>
          </div>
          <div className="w-full xl:w-1/2 flex flex-col justify-start">
            <div className="text-center flex flex-col gap-4">
              <h3
                data-aos="fade-up"
                className="text-[#d78558] font-robout text-2xl sm:text-3xl md:text-4xl lg:text-[3rem] leading-tight font-black"
              >
                Samir A. Amin, MD
              </h3>
              <span
                data-aos="fade-up"
                data-aso-delay="100"
                className="text-[#1d1d1f] text-sm sm:text-base md:text-lg lg:text-[1.3rem] font-robout"
              >
                - Diplomate, American Board of Radiology
              </span>
            </div>
            <div className="text-[#1d1d1f] text-lg md:text-lg lg:text-xl xl:text-[1.35rem] mt-6 sm:mt-8 md:mt-10 font-robout md:leading-relaxed">
              <p data-aos="fade-up" data-aso-delay="200">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum
              </p>
              <p data-aos="fade-up" data-aso-delay="300" className="mt-4">
                Nullam interdum scelerisque facilisis. Ut est urna, convallis
                vitae ante vitae, gravida luctus augue. Nulla convallis libero
                nisi, ac pharetra lacus consequat non. Sed scelerisque magna
                vitae nunc dapibus tincidunt.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
